import script from "./verticalText.vue?vue&type=script&setup=true&lang=js"
export * from "./verticalText.vue?vue&type=script&setup=true&lang=js"

import "./verticalText.vue?vue&type=style&index=0&id=335a649d&lang=css"

const __exports__ = script;

export default __exports__